import { PasswordInput, PasswordInputProps } from '@mantine/core';
import classes from './Inputs.module.css';

const StyledPasswordInput = (props: PasswordInputProps) => {
  return (
    <PasswordInput
      {...props}
      classNames={{
        input: classes.input,
        label: classes.label,
      }}
    />
  );
};

export default StyledPasswordInput;
